import React from 'react';
import { FlexRow, Typography } from 'design-system';
import { ExclamationCircleIcon } from 'design-system/components/Icons';

export default function SurveyQuestionFieldError({ message }) {
  if (!message) {
    return null;
  }

  return (
    <FlexRow className="ds-form-field__error" role="alert" align="start" fullWidth gap={6}>
      <ExclamationCircleIcon className="ds-form-field__error-icon" size={12} fill="var(--pal-red-1000)" />
      <Typography component="span" variant="bodyMedium" className="ds-form-field__error-text">
        {message}
      </Typography>
    </FlexRow>
  );
}
